import { render } from "./Index_concept_en.vue?vue&type=template&id=c48dcc92&scoped=true"
import script from "./Index_concept_en.vue?vue&type=script&lang=js"
export * from "./Index_concept_en.vue?vue&type=script&lang=js"

import "./Index_concept_en.vue?vue&type=style&index=0&id=c48dcc92&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c48dcc92"

export default script